module.exports = "<p>\n  Redirecting…\n</p>\n"


//////////////////
// WEBPACK FOOTER
// /home/runner/work/onelocal/onelocal/src/my-referral/src/app/page-not-found/page-not-found.component.html
// module id = ../../../../../../../../src/app/page-not-found/page-not-found.component.html
// module chunks = 1